import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";

const CancelSubscriptionModal = ({
  show,
  onHide,
  onConfirm,
  loading = false,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="text-danger">
          <FaExclamationTriangle className="me-2" />
          Cancel Subscription
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3 fw-semibold">
          Are you sure you want to cancel your subscription?
        </p>
        <p className="mb-3">
          If you click Confirm, your subscription will end immediately and you
          will lose access to your paid plan and API limits right away.
        </p>
        <p className="mb-0 text-muted">
          This action cannot be undone. You can purchase a new plan anytime
          from the Subscription page.
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Cancelling...
            </>
          ) : (
            "Confirm"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelSubscriptionModal;
